import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import work from "../../assets/Work.png";
import upload2 from "../../assets/up.jpg";

const CircularIcon = styled(Box)(({ theme }) => ({
  width: "100px",
  height: "100px",
  borderRadius: "50%",
  border: "2px solid #43BAB9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#F0F8F8",
  marginBottom: "20px",
}));

const UploadLogo = ({ imageSelected, logo, setLogo }) => {
  const handleUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogo(e.target.result);
        imageSelected(true);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        // background: "red",
      }}
    >
      <CircularIcon>
        {logo ? (
          <img
            src={logo}
            alt="Logo"
            style={{ width: "100%", height: "100%", borderRadius: "50%" }}
          />
        ) : (
          <img src={work} alt="Logo" height={50} width={50} />
        )}
      </CircularIcon>
      <input
        accept="image/*"
        style={{ display: "none" }}
        id="upload-button"
        type="file"
        onChange={handleUpload}
      />
      <label htmlFor="upload-button" style={{ cursor: "pointer" }}>
        <Box
          style={{
            padding: "8px 0",
            width: 180,
            height: 48,
            border: "1px solid #EEEEEE",
            borderRadius: "8px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            cursor: "pointer",
          }}
        >
          <img
            src={upload2}
            alt=""
            height={24}
            width={24}
            style={{ marginRight: "10px" }}
          />
          <Typography
            variant="body1"
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              color: "#585555",
              fontSize: "1rem",
            }}
          >
            {logo ? "Re upload" : "Upload Logo"}
          </Typography>
        </Box>
      </label>
    </Box>
  );
};

export default UploadLogo;
